import { Toaster } from "@/components/uiDir/toaster";
import { Toaster as Sonner } from "@/components/uiDir/sonner";
import { TooltipProvider } from "@/components/uiDir/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BetaBanner from "./components/BetaBanner";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import Explore from "./pages/Explore";
import PublicProfile from "./pages/PublicProfile";
import EditProfile from "./pages/dashboard/EditProfile";
import AddProject from "./pages/dashboard/AddProject";
import CustomizeTheme from "./pages/dashboard/CustomizeTheme";
import SharePortfolio from "./pages/dashboard/SharePortfolio";
import Settings from "./pages/dashboard/Settings";
import ResetPassword from "./pages/ResetPassword";
import Projects from "./pages/dashboard/Projects";
import Analytics from "./pages/dashboard/Analytics";
import Activities from "./pages/Activities";
import Docs from "./pages/Docs";
import Support from "./pages/Support";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import EditProject from "./pages/dashboard/EditProject";
import AllOpportunities from "./pages/AllOpportunities";
import AllProjects from "./pages/AllProjects";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <BetaBanner />
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/profile" element={<EditProfile />} />
          <Route path="/dashboard/projects" element={<Projects />} />
          <Route path="/dashboard/projects/new" element={<AddProject />} />
          <Route path="/dashboard/theme" element={<CustomizeTheme />} />
          <Route path="/dashboard/share" element={<SharePortfolio />} />
          <Route path="/dashboard/analytics" element={<Analytics />} />
          <Route path="/dashboard/settings" element={<Settings />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/discover/projects" element={<AllProjects />} />
          <Route path="/profile/:username" element={<PublicProfile />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/opportunities" element={<AllOpportunities />} />
          <Route path="/discover/projects" element={<AllProjects />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/dashboard/projects/edit/:projectId" element={<EditProject />} />

        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
